import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { InputSKU } from "../InputSKU";
import { useProductSKUForm } from "../../hooks";
import { Modal } from "../../../../../../components";
import { getSelfServiceConvention } from "../../../../../../store/selfServiceSlice";
import { MODAL_ID } from "../../../../../../utils/constants";
import FormContext from "../../../../../../context/formContext";
import { addProduct } from "../../../../../../store/conventionsSlice";
import { useWatchForm } from "../../../../hooks/useWatchForm";
import { updateModal } from "../../../../../../store/modalSlice";
import { FORM_KEYS } from "../../../../constants";

/**
 * @desc Add New Product Modal.
 */
export const AddProductModal = () => {
  const dispatch = useDispatch();
  const convention = useSelector(getSelfServiceConvention);
  const {
    control,
    watch,
    resetField,
    formState: { isValid },
  } = useProductSKUForm(convention ? convention.pskus : [], {});
  useWatchForm({ watch });
  const context = { control };

  // SIDE EFFECTS -------------------------------------------------------------

  /**
   * @desc Update modal's valid state.
   */
  useEffect(() => {
    dispatch(updateModal({ disabled: !isValid }));
  }, [dispatch, isValid]);

  // COMPONENT ----------------------------------------------------------------

  const modalProps = {
    id: MODAL_ID.ADD_NEW_PRODUCT,
    disabled: !isValid,
    header: "Add New Product",
    children: (
      <div className="add-new-product">
        <FormContext.Provider value={context}>
          <InputSKU />
        </FormContext.Provider>
      </div>
    ),
    ctaText: "OK",
    showCancelButton: true,
    onClick: async () => {
      try {
        await dispatch(addProduct());
        resetField(FORM_KEYS.ADD_PRODUCT_SKU);
        toast.success("Success");
      } catch (err) {
        toast.error(`Error: ${err.message}`);
      }
    },
  };

  return <Modal {...modalProps} />;
};

export default AddProductModal;
